import React from 'react';
import { useTranslation } from 'react-i18next';
import { T, TKeys } from '@/components/translation-helper';
import { Button } from './ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { cn } from '@/lib/utils';

export function LanguageSelector({ className }: { className?: string }) {
  const { t, i18n } = useTranslation('common');
  // Normalize region-qualified codes (e.g. "en-US") to the base language so it
  // matches the SelectItem values below ("en"/"es"/"fr"); otherwise the trigger
  // renders blank because no item matches the full "en-US" value.
  const currentLanguage = (i18n.language || 'en').split('-')[0];

  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language);
  };

  return (
    <div className={cn("flex flex-col space-y-2", className)}>
      <label className="text-sm font-medium text-muted-foreground">
        {t('common.language')}
      </label>
      <Select
        value={currentLanguage}
        onValueChange={changeLanguage}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder={t('common.selectLanguage')} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="en">English</SelectItem>
          <SelectItem value="es">Español</SelectItem>
          <SelectItem value="fr">Français</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
